const scoreOrder = "https://notification-service-v2-prod-uh44iwamqq-uc.a.run.app/api/v1/rating/";
const ratingOrders = "https://notification-service-v2-prod-uh44iwamqq-uc.a.run.app/api/v1/rating/score/";

export default {
  scoreOrder,
  ratingOrders,
};
